import { useContext, useEffect, useState } from "react"
import { Navigate, useNavigate, useParams } from "react-router-dom"
import { useHashTab } from "../../../../../hooks/useHashTab"
import { digitalManagerApi } from "../../../../../services/api"
import { DiMaDetailsHeaderProps } from "../../../../components/DiMaDetailsHeader"
import { DiMaProgress } from "../../../../components/DiMaProgress"
import { renderDetailsTabWithGrid } from "../../../../components/Helpers"
import { UserContext } from "../../../../context/UserContext"
import { DeviceSoftwarePackageFirmwareConstraintGet } from "../../../../models/DeviceSoftwarePackageFirmwareConstraint"
import { DeviceSoftwarePackageFirmwareConstraintDetails } from "./details_tab/DeviceSoftwarePackageFirmwareConstraintDetails"

export function DeviceSoftwarePackageFirmwareConstraintContainer() {
  const { user, isLoadingUser } = useContext(UserContext)

  const { deviceId, softwarePackageFirmwareConstraintId } = useParams()
  const navigate = useNavigate()
  const { activeTab, handleTabChange } = useHashTab("details")

  const [softwarePackageFirmwareConstraint, setSoftwarePackageFirmwareConstraint] =
    useState<DeviceSoftwarePackageFirmwareConstraintGet>()

  const returnURL = `/devices/${deviceId}#software-package-firmware-constraints`

  useEffect(() => {
    if (deviceId && softwarePackageFirmwareConstraintId) {
      digitalManagerApi
        .get<DeviceSoftwarePackageFirmwareConstraintGet>(
          `/devices/${deviceId}/softwarePackageFirmwareConstraints/${softwarePackageFirmwareConstraintId}`
        )
        .then((res) => {
          setSoftwarePackageFirmwareConstraint(res.data)
        })
        .catch((err) => {
          if (err.response.status) {
            navigate(returnURL)
          }
        })
    }
  }, [deviceId, navigate, returnURL, softwarePackageFirmwareConstraintId])

  if (!deviceId || !softwarePackageFirmwareConstraintId) {
    return <Navigate to="/devices" />
  }

  if (!softwarePackageFirmwareConstraint || isLoadingUser || !user) {
    return <DiMaProgress />
  }

  const detailsHeaderProps: DiMaDetailsHeaderProps = {
    url: returnURL,
    title: softwarePackageFirmwareConstraint.softwarePackageEditionCode,
    label: "Software Package Firmware Constraint ID",
    subtitle: softwarePackageFirmwareConstraint.id,
  }

  return renderDetailsTabWithGrid({
    detailsHeaderProps,
    activeTab,
    handleTabChange,
    DetailsComponent: DeviceSoftwarePackageFirmwareConstraintDetails,
    detailsComponentProps: {
      softwarePackageFirmwareConstraint,
      deviceId,
      user,
      setSoftwarePackageFirmwareConstraint,
    },
  })
}
